<template>
<div>
    <v-menu :ref="fieldName" v-model="dateMenu[fieldName]"
        :return-value.sync="objectForm[fieldName]"
        :close-on-content-click="false" :nudge-right="40" transition="scale-transition" 
        offset-y min-width="290px" style="z-index:1500">
        <template v-slot:activator="{ on, attrs }">
            <v-text-field :style="(width) ? 'width:' + width + ';' : ''" @focus="$event.target.select()"
                clear-icon="mdi-close-circle" clearable @click:clear="clearDate"
                v-bind="attrs" :value="(objectForm[fieldName]) ? $date(objectForm[fieldName]).format('DD/MM/YYYY') : ''"
                :label="label" :prepend-icon="prependIcon" :readonly="false" v-on="on" :rules="[dateRules]" 
                @input="checkManualEntry" @blur="checkManualEntryBlur" :placeholder="$date().format('DD/MM/YYYY')">
            </v-text-field>
        </template>
        <v-date-picker locale="fr-fr" no-title scrollable 
            @input="$refs[fieldName].save( objectForm[fieldName] )"
            v-model="objectForm[fieldName]" first-day-of-week="1" @change="$emit('change')">
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="dateMenu[fieldName] = false">Annuler</v-btn>
            <v-btn color="primary" @click="$refs[fieldName].save( objectForm[fieldName] )">OK</v-btn>
        </v-date-picker>
    </v-menu>
</div>
</template>

<script>

export default {
    name: 'date_picker',
    props: ['objectForm', 'fieldName', 'label', 'disabled', 'customStyle', 'preicon', 'width'],
    computed: {
        dateRules () {
            if ( this.objectForm[this.fieldName] == null || this.$date( this.objectForm[this.fieldName] ).isValid() ){
                return true
            } else {
                return 'Date non valide'
            }
        }
    },
    data: function () {
        return {
            loading     : { getVersion: false, getRessource: false },
            ischange    : false,
            //preprendIcon  : 'mdi-account',
            //params        : '',
            //isDisabled    : this.disabled || false,
            //outlined      : false,
            //dense         : false,
            //style         : (this.customStyle == undefined) ? 'z-index:2000;' : this.customStyle,
            dateMenu      : { [this.fieldName]: false },
            prependIcon   : 'mdi-calendar-today',
            manualEntry   : ''
        }
    },
    beforeMount: function(){

    },
    mounted:function (){
        this.prependIcon = (typeof this.preicon !== 'undefined') ? this.preicon : 'mdi-calendar-today'
        //this.preprendIcon = (this.fields.preprendIcon == undefined) ? undefined : this.fields.preprendIcon
        //this.outlined     = (this.fields.outlined === true) ? true : false
        //this.dense        = (this.fields.dense === true) ? true : false
        if( !this.$date( this.objectForm[this.fieldName] ).isValid() ){
            this.objectForm[this.fieldName] = null //this.$date().format('YYYY-MM-DD')
        }
    },
    methods: {
        clearDate(){
            this.objectForm[this.fieldName] = null
        },
        checkManualEntry(value){
            if( !value ){
                this.clearDate()
                return false
            }
            if( value.length == 10 && value.includes('/') ){
                let newValue = value.substr(6, 4) + '-' + value.substr(3, 2) + '-' + value.substr(0, 2)
                value = newValue
            }
            if( value.length == 8 && !value.includes('/') ){
                let newValue = value.substr(4, 4) + '-' + value.substr(2, 2) + '-' + value.substr(0, 2)
                value = newValue
            }
            if( value.length == 10 && this.$date( value ).isValid() ){
                this.objectForm[this.fieldName] = this.$date( value ).format('YYYY-MM-DD')
                this.$refs[this.fieldName].save( this.objectForm[this.fieldName] )
            }
        },
        checkManualEntryBlur(event){
            let value = event.target._value
            let newValue = ''
            if( value && value.length == 10 && value.includes('/') ){
                newValue = value.substr(6, 4) + '-' + value.substr(3, 2) + '-' + value.substr(0, 2)
            }
            if( value && ( value.length !== 10 || !this.$date( newValue ).isValid() ) ){
                this.clearDate()
            }
        }
    }
}
</script>